import React from 'react'
import PropTypes from 'prop-types'
import { StandardFooter } from './StandardFooter'
import { CustomFooterContainer } from './CustomFooter'

import './style.css.scss'

const Footer = ({ config, themeColorHex }) => {
  return (
    <section className="footer-container">
      { config.is_standard ? (
        <StandardFooter config={config} />
      ) : (
        <CustomFooterContainer config={config} themeColorHex={themeColorHex} />
      )}
    </section>
  )
}

Footer.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default Footer
